import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ModalPortal from './components/Modal/ModalPortal/ModalPortal';
import 'intersection-observer';

let root;

export const render = (store, container, history, language) => {
  ModalPortal.setRootSelector(container);

  try {
    const DOM_NODE = document.querySelector(container);

    root = createRoot(DOM_NODE);
    root.render(
      <React.StrictMode>
        <App store={store} history={history} language={language} />
      </React.StrictMode>
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(
      'Could not mount application component at node.\r\nSeems like there is no DOM node with such selector.',
      e
    );
  }
};

export const destroy = () => {
  try {
    root.unmount();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(
      'Could not unmount application component at node.\r\nSeems like there is no DOM node with such selector.',
      e
    );
  }
};
